import { useEffect, useState } from 'react';
import { AuthErrorCodes, PhoneAuthProvider, PhoneMultiFactorGenerator } from 'firebase/auth';

// @mui
import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
// hooks
import { useAuthContext } from '../../../auth/useAuthContext';
// layouts
import LoginLayout from '../../../layouts/login';
//
import MFAEnrollPhoneForm from './MFAEnrollPhoneForm';
import MFAEnrollCodeForm from './MFAEnrollCodeForm';
// ----------------------------------------------------------------------

export default function MFAEnroll(params) {
    const {mfaUser} = params;
    const { method, logout, getPhoneAuthProvider } = useAuthContext();
    const [stage, setStage] = useState("stage1");
    const [phone, setPhone] = useState("");
    const [verifyId, setVerifyId] = useState("");

    // const currentUser = getCurrentUser();

    const sendVerifyPhoneCode = (newPhone)=>{
        mfaUser.getSession().then((multiFactorSession)=>{
            const phoneInfoOptions = {
                phoneNumber: `+${newPhone}`,
                session: multiFactorSession
            };
            const provider = getPhoneAuthProvider();
            provider.verifyPhoneNumber(phoneInfoOptions, window.recaptchaVerifier)
            .then((verificationId)=>{
                setVerifyId(verificationId);
                setStage("stage2");
                // setLoading("done");
            }).catch((error)=>{
                if(error.code === AuthErrorCodes.CREDENTIAL_TOO_OLD_LOGIN_AGAIN ){
                    logout();
                    window.location.href = '/';
                }
            });
        })
        .catch((error)=>{
            console.log(error);
        })
    }

    const enrollMFA = (code)=>{
        const cred = PhoneAuthProvider.credential(verifyId, code);
        const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
        try{
            mfaUser.enroll(multiFactorAssertion, 'My personal phone number')
            .then((data)=>{
                console.log(data);
                window.location.href = "/dashboard";
            })
        } catch(error){
        if(error.code === AuthErrorCodes.CREDENTIAL_TOO_OLD_LOGIN_AGAIN ){
            logout();
            window.location.href = '/';
        }
        console.log(error);
        }  
    }


    return (
        <LoginLayout>
        

        {
            stage ==="stage1" &&
            <MFAEnrollPhoneForm 
                setPhone={setPhone}
                sendVerifyPhoneCode={sendVerifyPhoneCode}
                setStage={setStage}
            />
        }
        {
            stage === "stage2" &&
            <MFAEnrollCodeForm 
                setStage={setStage}
                phone={phone}
                enrollMFA={enrollMFA}
            />
        }

        <div id="recaptcha-container"/>


        {/* <AuthWithSocial /> */}
        </LoginLayout>
    );
}
